/**
 * @enum PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD
 * @type {{YEARLY: string, MONTHLY: string}}
 */
export const PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

/**
 * PhotoManagerSubscription features.
 *
 * @type {string[]}
 */
export const PHOTO_MANAGER_SUBSCRIPTION_FEATURES = [
  '1TB cloud storage with affordable upgrades',
  'Unlimited contributors',
  'Automated branding & hashing',
  'Photo publishing moderation',
  'Mobile optimized web gallery',
  'Custom tagging & searching',
  'Custom, branded prints',
  'Personalized direct mail builder',
  'Live slideshows',
];

/**
 * Checks if an Account is eligible for a PhotoManager subscription trial.
 *
 * @param {Object} [account] The Account.
 * @returns {*}
 */
export const isEligibleForPhotoManagerFreeTrial = account => {
  return (
    !account?.pro_settings?.has_free_photo_manager &&
    account?.photo_manager_subscription_free_trial_enabled
  );
};
